import { AfterViewInit, Directive, ElementRef } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map, mergeMap, take } from 'rxjs/operators';
import { GA4 } from '../models/ga4.model';




@Directive()
export abstract class ViewDirective<T extends GA4.ItemArray> implements AfterViewInit {
    abstract track: T;
    constructor(private element: ElementRef) {}
    ngAfterViewInit(): void {
        new Observable(_observer => {
            const intersectionObserver = new IntersectionObserver(entries => _observer.next(entries));
            intersectionObserver.observe(this.element.nativeElement);
            return () => intersectionObserver.disconnect();
        }).pipe(
            mergeMap((entries: IntersectionObserverEntry[]) => entries),
            map(entry => entry.isIntersecting),
            filter(_ => _),
            take(1)
        ).toPromise()
            .then(() => new Promise((resolve) => {
                const fn = () => {
                    if (this?.track?.items?.length > 0)
                        resolve(true);
                    else
                        setTimeout(() => { fn(); }, 200);
                }
                fn();
            }))
            .then(() => queueMicrotask(() => GA4.track(this.track)));
    }
}
